import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { queueApi } from './queue.api';
import type { NextClientResponse, QueueResponse } from '@/types/api';

export const QUEUE_KEY = ['queue', 'me'] as const;

/**
 * My agent queue, one page at a time. Refetches on focus and every 60s
 * while mounted — poll is the current page (default 50 rows), not the
 * whole pending universe.
 */
export function useQueue(opts?: { limit?: number; offset?: number }) {
  const limit = opts?.limit ?? 50;
  const offset = opts?.offset ?? 0;
  return useQuery<QueueResponse>({
    queryKey: [...QUEUE_KEY, limit, offset],
    queryFn: () => queueApi.list({ limit, offset }),
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}

/**
 * Take next from queue. On success, invalidate queue cache so the list
 * reflects the claimed assignment moving to in_progress.
 */
export function useTakeNext() {
  const qc = useQueryClient();
  return useMutation<NextClientResponse, Error>({
    mutationFn: queueApi.takeNext,
    onSuccess: () => {
      // R3: 'all' — el conteo de la QueuePage refresca aunque este desmontada.
      void qc.invalidateQueries({ queryKey: QUEUE_KEY, refetchType: 'all' });
      void qc.invalidateQueries({ queryKey: ['agents', 'me', 'dashboard'], refetchType: 'all' });
    },
  });
}
